// @vue/component
import ShPopConfirm from '@/components/Helpers/ShPopConfirm';
import AddressBookItemEditForm from './AddressBookItemEditForm';

export default {
  name: 'AddressBookItem',

  components: {
    ShPopConfirm,
    AddressBookItemEditForm,
  },

  props: {
    addressBookItem: {
      type: Object,
      default: () => ({}),
    },
    agentsList: {
      type: Array,
      default: () => [],
    }
  },

  data() {
    return {
      isElementLoading: false,
      isVip: this.addressBookItem.vip,
      isEditModalFormOpen: false,
      selectedAgent: '',
      isCalling: false,
      isAgentPopoverVisible: false,
    };
  },
  created() {
    if (this.agentsList.length === 1) {
      this.selectedAgent = this.agentsList[0].uuid
    }
  },

  computed: {
    isLoading() {
      return this.$store.getters['global/pendingAsyncStoreActions'].includes([
        'addressBook/getList', 'addressBook/removeNumber']);
    },
  },

  methods: {
    async removeNumber() {
      const params = {
        number: this.addressBookItem.uuid,
      };
      await this.$store.dispatch('addressBook/removeNumber', params);
      this.$message({
        title: 'Sukces',
        message: 'Numer został usunięty z książki adresowej',
        type: 'success',
      });
      await this.$store.dispatch('addressBook/getList');
    },
    toggleEditFormModal() {
      this.isEditModalFormOpen = !this.isEditModalFormOpen;
    },
    async makeCall() {
      this.isCalling = true;
      const params = {
        agent: this.selectedAgent,
        number_b: this.addressBookItem.num_a,
      };
      const result = await this.$store.dispatch('user/agent/makeCall', params);
      if (result !== 0) {
        this.$message({
          title: 'Sukces',
          message: 'Następuje próba połączenia.',
          type: 'success',
        });
      } else {
        this.$message({
          message: 'Wystąpił bład podczas próby połączenia.',
          type: 'error',
        });
      }
      this.isCalling = false;
    }
  },
  watch: {
    addressBookItem(item) {
      this.isVip = item['vip'];
    },
  },
};
